<div class="container-fluid p-0">
  <form #f="ngForm" class="form-container" (ngSubmit)="onSubmit(f)">
    <div class="card rounded-0">
      <div class="card-body">

        <div class="row pt-3">
          <div class="col">
            <app-address-lookup
              label="Address / Address Lookup"
              placeholder="Address / Address Lookup"
              [required]="true"
              name="location"
              [(ngModel)]="site.location"
              [locationBiasProvider]="getMapBoundsBias"
              (addressSelected)="onAddressSelected($event)">
            </app-address-lookup>
          </div>
        </div>

        <div class="row">
          <div class="col">

            <small>
              Use the map below to draw a geofence. Click points on the map to outline the area, then drag the points to fine tune it. The default max geofence size is 50000 m2.
            </small>

            <div #map id="map" appMarginTop></div>

            <small><b>Allowed Geofence Size:</b> {{ site.max_geofence_size }} &#13217; | <b>Current Size:</b> {{ site.geofence_size | number: '1.0-0' }} &#13217;</small>

            <div class="alert alert-danger" role="alert" *ngIf="site.geofence_size > site.max_geofence_size">
              <small>
                Please reduce the size of the Geofence. <br>
                Contact {{ utils.getAppName() }} at <a [href]="'mailto:' + utils.getSupportEmailAddress()" target="_blank">{{ utils.getSupportEmailAddress() }}</a> for assistance with a larger geofence. <br>
                Draw a smaller geofence and click save before contacting {{ utils.getAppName() }}.
              </small>
            </div>

          </div>
        </div>

        <div class="row mt-2">
          <div class="col">

            <button
              mat-raised-button
              class="my-2 ml-0 mr-2"
              [disabled]="!f.valid || inProgress || site.geofence_size > site.max_geofence_size"
              (click)="onSubmit(f)"
              type="button"
              color="primary">
              <mat-icon>save</mat-icon> Save
            </button>

            <button
              mat-raised-button
              class="my-2 ml-1 mr-2"
              type="button"
              (click)="resetMapControls()"
              color="secondary">
              <mat-icon>restore</mat-icon> Reset Map
            </button>

          </div>
        </div>

      </div>
    </div>
  </form>
</div>
